"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AiSparklesIcon_1 = require("./AiSparklesIcon");
Object.defineProperty(exports, "AiSparklesIcon", { enumerable: true, get: function () { return AiSparklesIcon_1.AiSparklesIcon; } });
